import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import { IconArrowUpRight } from '@tabler/icons-react';

const Ourservices = () => {
  return (
    <>
      <section className='services'>
        <Container>
          <Row className='justify-content-between align-items-end'>
            <Col md={12}>
              <div className="head-title">
                <div className="sup">Our Services</div>
                <h2>Global Financial <span className='text-gradient'>Services</span></h2>
              </div>
            </Col>
          </Row>
          <Row className='justify-content-between'>
            <Col lg={3} sm={6} className='mb-4'>
              <Link to="/effortlessglobalpayments" className="box">
                <img src="../Images/effortless-global-payments.png" alt="" />
                <h3>Effortless Global Payments</h3>
                <p>Send money globally in major currencies with fast, cost-effective transfers.</p>
                <button as={Link} to="/effortlessglobalpayments" className='button yellow p-1 rounded-pill'><IconArrowUpRight size={20} stroke={2} /></button>
              </Link>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <Link to="/applyforletterofcredit" className="box">
                <img src="../Images/apply-for-letter-of-credit.png" alt="" />
                <h3>Apply for Letter of Credit</h3>
                <p>Secure international trade with reliable LC issuance for businesses.</p>
                <button as={Link} to="/applyforletterofcredit" className='button yellow p-1 rounded-pill'><IconArrowUpRight size={20} stroke={2} /></button>
              </Link>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <Link to="/tuitionpaymentsforcanada" className="box">
                <img src="../Images/tuition-payments-for-canada.png" alt="" />
                <h3>Tuition Payments for Canada</h3>
                <p>Hassle-free, secure tuition payments to canadian institutions at competitive rates.</p>
                <button as={Link} to="/tuitionpaymentsforcanada" className='button yellow p-1 rounded-pill'><IconArrowUpRight size={20} stroke={2} /></button>
              </Link>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <Link to="/realestateinvestmentpayments" className="box">
                <img src="../Images/real-estate-payments.png" alt="" />
                <h3>Real Estate Payments</h3>
                <p>Simplify property transactions with secure, efficient cross-border payment solutions.</p>
                <button as={Link} to="/realestateinvestmentpayments" className='button yellow p-1 rounded-pill'><IconArrowUpRight size={20} stroke={2} /></button>
              </Link>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Ourservices